import React, { useEffect, useState } from "react";
import { Modal, Form, Select, Input, Button, message, Spin } from "antd";
import { fetchApprovalTemplates, initiateApproval } from "../../api"; // Use wrapper API

const SubmitApprovalDialog = ({
  visible,
  onClose,
  module,
  objectId,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // Fetch templates for the module
  useEffect(() => {
    if (visible) {
      setLoading(true);
      fetchApprovalTemplates()
        .then((res) => {
          setTemplates(
            (res || []).filter((tpl) => tpl.module === module)
          );
        })
        .catch(() => messageApi.error("Failed to load approval templates"))
        .finally(() => setLoading(false));
    }
  }, [visible, module]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await initiateApproval({
        module,
        objectId,
        templateId: values.templateId,
        context: values.context,
      });
      messageApi.success("Approval flow started!");
      form.resetFields();
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      messageApi.error(
        err?.response?.data?.message || "Failed to start approval flow"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Submit for Approval"
      onCancel={onClose}
      onOk={handleOk}
      okText="Submit"
      confirmLoading={submitting}
      destroyOnClose
    >
      {contextHolder}
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item label="Module" name="module" initialValue={module}>
            <Input value={module} disabled />
          </Form.Item>
          <Form.Item label="Object ID" name="objectId" initialValue={objectId}>
            <Input value={objectId} disabled />
          </Form.Item>
          <Form.Item
            label="Approval Template"
            name="templateId"
            rules={[{ required: true, message: "Please select a template" }]}
          >
            <Select placeholder="Select template">
              {templates.map((tpl) => (
                <Select.Option key={tpl._id} value={tpl._id}>
                  {tpl.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Context (e.g. branch, region)"
            name="context"
            rules={[{ required: true, message: "Please enter context" }]}
          >
            <Input placeholder="Enter context (e.g. branch=Chennai)" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default SubmitApprovalDialog;
